import * as types from 'legacy/src/constants/types';

const data = (
  state = {
    filters: [],
    subjectId: '',
  },
  action,
) => {
  switch (action.type) {
    case types.UNIT_FILTERS_DATA:
      return action.payload || state;
    default:
      return state;
  }
};

export default data;
